import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { ReportInsight, ReportInsightType } from './useReportInsights';
import useRouterMatch from './useRouterMatch';

const useEditReportInsight = () => {
  const queryClient = useQueryClient();
  const { gameId: livePresentationId } = useRouterMatch();
  const { mutate: editReportInsight, isPending: isLoading } = useMutation({
    mutationFn: async ({
      insightId,
      promptOutput,
    }: {
      insightId: string;
      promptOutput: string;
      reportType: string;
    }) => {
      return BackendService.instance.ai.editReportInsight({
        insightId,
        promptOutput,
      });
    },

    onMutate: async ({ promptOutput, reportType }) => {
      queryClient.setQueryData(
        ['report-insight', reportType, livePresentationId, ''],
        (oldData: ReportInsight | undefined) => {
          if (oldData) {
            return {
              ...oldData,
              promptOutput,
            };
          }
          return oldData;
        },
      );
    }
  });

  return {
    editReportInsight,

    isLoading,
  };
};

export default useEditReportInsight;
